import { ReactNode, useEffect } from 'react';
import { SafeArea } from 'antd-mobile';
import { BottomNav } from './BottomNav';
import { Toast } from './Toast';
import { useStore } from '../store';
import './Layout.css';

interface LayoutProps {
    children: ReactNode;
    hideNav?: boolean;
}

export function Layout({ children, hideNav = false }: LayoutProps) {
    const themeMode = useStore((s) => s.themeMode);

    // Apply theme on mount and when changed
    useEffect(() => {
        const root = document.documentElement;
        if (themeMode === 'dark') {
            root.classList.add('dark');
            root.setAttribute('data-prefers-color-scheme', 'dark');
        } else {
            root.classList.remove('dark');
            root.setAttribute('data-prefers-color-scheme', 'light');
        }
    }, [themeMode]);

    // Prevent overscroll on touch devices
    useEffect(() => {
        const preventOverscroll = (e: TouchEvent) => {
            const target = e.target as HTMLElement;
            // Allow scrolling in elements with .page-content or .scroll-y class
            if (target.closest('.page-content, .scroll-y')) {
                return;
            }
            // Prevent default for everything else
            if (e.touches.length === 1) {
                e.preventDefault();
            }
        };

        document.addEventListener('touchmove', preventOverscroll, { passive: false });

        return () => {
            document.removeEventListener('touchmove', preventOverscroll);
        };
    }, []);

    return (
        <div className="app-wrapper">
            <div className="app-container">
                {/* Main Content */}
                <main className="app-content">
                    {children}
                </main>

                {/* Bottom Navigation */}
                {!hideNav && <BottomNav />}

                {/* Toast notifications */}
                <Toast />
            </div>
        </div>
    );
}

export default Layout;
